import {Action} from "../action";
import type {State} from "../..";

export const ERROR_ACTION = "ERROR_ACTION";

/**
 * This Action is always available on all states
 * Whenever a breaking Error happens in the Frontend, this Action should be called.
 */

export class GoToErrorState extends Action<typeof ERROR_ACTION, undefined> {
  readonly type = ERROR_ACTION;

  protected state: State<any, any>;

  constructor(state: State<any, any>) {
    super(state);
    this.state = state;
  }

  public isValid(): boolean {
    return this.isDoable();
  }
  public isDoable(): boolean {
    return true;
  }
}
